import HttpRequester from './HttpRequester';
import { runReducersFirst } from './runReducersFirst';
export const HttpRequesterMiddleware = store => next => action => {
  const dispatchResult = runReducersFirst(next, action);
  HttpRequester.fetchAll(action, store.dispatch, store.getState);
  return dispatchResult;
};